export function defaultReducer<T>(state: T) {
  return state;
}
